import { gsap, Back } from "gsap";

/**
 *
 * @param {SVGPathElement | null} cursorBall
 */
export function appAnimateCursorIcon(cursorBall) {
  if (cursorBall !== null) {
    const timeline = gsap.timeline({ repeat: -1, defaults: { ease: Back.easeOut(2) } });

    timeline.to(cursorBall, { y: 14, delay: 0.64 });
    timeline.to(cursorBall, { opacity: 0 });
    timeline.to(cursorBall, { y: 0 });
    timeline.to(cursorBall, { opacity: 1 });

    /* frame 1 */
    // timeline.to(cursorBall, {
    //   d: "M18,31.02436C19.1,31.02436,20,30.12436,20,29.02436L20,29C20,27.9,19.1,27,18,27C16.9,27,16,27.9,16,29L16,29.02436C16,30.12436,16.9,31.02436,18,31.02436Z",
    // });
    // /* frame 2 */
    // timeline.to(cursorBall, {
    //   d: "M18 37C19.1 37 20 36.1 20 35V29C20 27.9 19.1 27 18 27C16.9 27 16 27.9 16 29V35C16 36.1 16.9 37 18 37Z",
    // });
    // /* frame 3 */
    // timeline.to(cursorBall, {
    //   d: "M18,37C19.1,37,20,36.1,20,35L20,29C20,27.9,19.1,27,18,27C16.9,27,16,27.9,16,29L16,35C16,36.1,16.9,37,18,37Z",
    // });
    // /* frame 4 */
    // timeline.to(cursorBall, {
    //   d: "M18,37C19.1,37,20,36.1,20,35L20,35.012116C20,33.912116,19.1,33.012116,18,33.012116C16.9,33.012116,16,33.912116,16,35.012116L16,35C16,36.1,16.9,37,18,37Z",
    // });
  }
}
